import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { dateFormat } from '@app/constants'

import { getFormattedDate } from '@app/utils/date'

import styles from './styles.module.scss'

import type { NotificationValueItemProps } from './types'

export const NotificationItem: React.FC<NotificationValueItemProps> = ({ notificationData }) => {
  const { isNew, baseSectionUrl, relatedEntityId, title, text, createdAt } = notificationData

  const className = classNames(styles.notificationItem, {
    [styles.notificationItem_new]: isNew
  })

  return (
    <Link to={ { pathname: baseSectionUrl, search: `id=${relatedEntityId}` } }>
      <div className={ className }>
        <span className={ styles.notificationItem__title }>{ title }</span>

        <span>{ text }</span>

        <span className={ styles.notificationItem__date }>
          { getFormattedDate(createdAt, dateFormat.DD_MM_YYYY_HH_mm) }
        </span>
      </div>
    </Link>
  )
}
